<!-- <div class="loader" [ngClass]="{ 'd-none': !loadingService.isLoading }">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div> -->
<!-- Unified loader: shows for both loading service and route resolver -->
<div class="preloader"
     [class.solid-backdrop]="showResolverLoader"
     *ngIf="(loadingService.isLoading || showResolverLoader) && isIgnatiusThemeApplied">
  <div class="spinner">
    <div class="double-bounce1"></div>
    <div class="double-bounce2"></div>
  </div>
</div>
<div class="progress-backdrop"
     [class.solid-backdrop]="showResolverLoader"
     *ngIf="(loadingService.isLoading || showResolverLoader) && !isIgnatiusThemeApplied">
  <mat-spinner
    [diameter]="progressProps.medium.diameter"
    [strokeWidth]="progressProps.medium.strokeWidth"
    mode="indeterminate" >
  </mat-spinner>
</div>
<app-header *ngIf="!isFileView"></app-header>

<ng-container *ngIf="isAuthAccessibilityEnabled; else legacyHelpButton">
  <a [href]="openOGSupportLink()" target="_blank"
  rel="noopener noreferrer" id="custom-help-button" >
    <i class="iconhelp-outline" aria-hidden="true"></i><span>Help</span>
  </a>
</ng-container>
<ng-template #legacyHelpButton>
  <div id="custom-help-button" (click)="openOGSupport()">
    <i class="iconhelp-outline"></i><span>Help</span>
  </div>
</ng-template>
<router-outlet *ngIf="isFileView"></router-outlet>
